import jsPDF from 'jspdf';
import { InvoiceData } from '../models/invoice';
import { environment } from 'src/environments/environment';

export const generatePdf = (data: InvoiceData) => {
  const doc = new jsPDF();

  const logo = new Image();
  logo.src = 'assets/logo.png';
  logo.width = 10;
  logo.height = 10;

  logo.onload = () => {
    // 1. Logo (haut gauche)
    doc.addImage(logo, 'PNG', 10, 10, 15, 10);

    let y = 60;
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`FACTURE`, 10, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`Numéro de facture: ${data.invoiceNumber}`, 10, y + 6);
    doc.text(`Date: ${new Date(data.date).toLocaleDateString()}`, 10, y + 12);

    //Infos Tipay
    y += 30;
    doc.setFont('helvetica', 'bold');
    doc.text(`TIPAY`, 10, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`Adresse: ${environment.tipay.address}`, 10, y + 6);
    doc.text(`Téléphone: ${environment.tipay.phone}`, 10, y + 12);
    doc.text(`Email: ${environment.tipay.email}`, 10, y + 18);

    //Infos Client
    y += 36;
    doc.setFont('helvetica', 'bold');
    doc.text(`DETAILS CLIENT`, 10, y);
    doc.setFont('helvetica', 'normal');
    doc.text(`Nom: ${data.customerName}`, 10, y + 6);
    doc.text(`NINEA: ${data.customerNinea}`, 10, y + 12);
    doc.text(`Identifiant Tipay: ${data.customerId}`, 10, y + 18);

    // 6. Tableau produit - Affichage conditionnel selon le type
    y += 36;
    doc.setFont('helvetica', 'bold');

    // Vérifier si c'est des Tickets Restaurant
    const isTicketRestaurant = data.items.some(item =>
      item.description === 'Tickets Restaurant'
    );

    if (isTicketRestaurant) {
      // Avec colonne Quantité (pour Tickets Restaurant uniquement)
      doc.text('Description', 10, y);
      doc.text('Quantité', 100, y);
      doc.text('Prix unitaire', 130, y);
      doc.text('Total', 170, y);
    } else {
      // Sans colonne Quantité (pour Chèques Cadeaux et Chèques Vacances)
      doc.text('Description', 10, y);
      doc.text('Montant', 150, y);
    }

    y += 6;
    doc.line(10, y, 200, y);
    y += 10;

    data.items.forEach((item) => {
      const total = item.quantity * item.unitPrice;
      doc.setFont('helvetica', 'normal');

      if (isTicketRestaurant) {
        // Affichage avec quantité
        doc.text(item.description, 10, y);
        doc.text(`${item.quantity}`, 105, y);
        doc.text(`${item.unitPrice} XOF`, 135, y);
        doc.text(`${total} XOF`, 175, y);
      } else {
        // Affichage sans quantité (juste description et montant)
        doc.text(item.description, 10, y);
        doc.text(`${total} XOF`, 155, y);
      }

      y += 6;
      doc.line(10, y, 200, y);
      y += 10;
    });

    // 7. Total
    y += 15;
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text(`Total : ${data.totalAmount} XOF`, 170, y, { align: 'right' });

    // 8. Footer
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100);
    doc.text('Merci pour votre confiance.', 105, 280, { align: 'center' });

    // 9. Sauvegarde
    doc.save(`facture-${data.customerName}-${data.invoiceNumber}.pdf`);
  };
};

const MASK_128 = (1n << 128n) - 1n;

export function unpackBaseTicketId(packedId: string | bigint): number {
  const packed = BigInt(packedId);
  return Number(packed >> 128n);
}

export function isPackedTicketId(tokenId: string | bigint | number): boolean {
  return BigInt(tokenId) > (1n << 120n);
}
